export default "/images/vendor/flag-icon-css/flags/4x3/nr.svg?94f7307aad6675681fef606ed402a249";